import LocalStorage from "@/classes/local-storage";
import App from "@/components/app";
import { globals } from "@/globals";
import "@/globals.css";
import translationEnUs from "@/translations/en-us.json";
import translationZhCn from "@/translations/zh-cn.json";
import translationZhTw from "@/translations/zh-tw.json";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import i18n, { t } from "i18next";
import "node-waves/dist/waves.min.css";
import ReactDOM from "react-dom/client";
import { initReactI18next } from "react-i18next";

const queryClient = new QueryClient();

function printWelcomeToConsole(): void {
	if (globals.isMobile) {
		return;
	}

	const styles = {
		primary: {
			color: "#70C000",
			fontFamily:
				"'Microsoft Yahei', PingFangSC-Regular, Helvetica, sans-serif, '等线'",
			lineHeight: "20px",
		},
		secondary: {
			fontFamily:
				"'Microsoft Yahei', PingFangSC-Regular, Helvetica, sans-serif, '等线'",
			lineHeight: "20px",
		},
	};

	const styleObjectToString = (
		styleObject: Record<string, string>,
	): string => {
		return (
			Object.entries(styleObject)
				.map(([key, value]) => key + ": " + value)
				.join("; ") + ";"
		);
	};

	const primaryStyle = styleObjectToString({
		"color": styles.primary.color,
		"font-family": styles.primary.fontFamily,
		"line-height": styles.primary.lineHeight,
	});
	const secondaryStyle = styleObjectToString({
		"font-family": styles.secondary.fontFamily,
		"line-height": styles.secondary.lineHeight,
	});
	const logoStyle = styleObjectToString({
		color: styles.primary.color,
	});

	const limeLogo =
		" _       _____  __  __  ______ \n" +
		"| |     |_   _||  \\/  ||  ____|\n" +
		"| |       | |  | \\  / || |__   \n" +
		"| |       | |  | |\\/| ||  __|  \n" +
		"| |____  _| |_ | |  | || |____ \n" +
		"|______||_____||_|  |_||______|";

	const welcomeMessage =
		"\n%cLime Start Page %cVersion " +
		globals.VERSION +
		"\n%c欢迎来到青柠起始页！\n" +
		"%c" +
		limeLogo +
		"\n\n" +
		"%c青柠起始页已上线 %c" +
		globals.limeAge +
		"%c 天\n" +
		"%c© 2025 Retinbox. All Rights Reserved.\n";

	console.info(
		welcomeMessage,
		primaryStyle,
		secondaryStyle,
		primaryStyle,
		logoStyle,
		primaryStyle,
		secondaryStyle,
		primaryStyle,
		secondaryStyle,
	);
}

const i18nResources = {
	"en-US": {
		translation: translationEnUs,
	},
	"zh-CN": {
		translation: translationZhCn,
	},
	"zh-TW": {
		translation: translationZhTw,
	},
};

const lang = ((): string => {
	const { language } = LocalStorage.getGeneralSettings();
	if (language && language in i18nResources) {
		return language;
	} else if (
		!navigator.language ||
		/^(yue|zh)(-cn|-sg|-hans(-[a-z]+)?)?$/i.test(navigator.language) ||
		(/bot|spider/i.test(navigator.userAgent) &&
			!navigator.userAgent.includes("Googlebot"))
	) {
		return "zh-CN";
	} else if (
		navigator.language.startsWith("zh") ||
		navigator.language.startsWith("yue")
	) {
		return "zh-TW";
	} else {
		return "en-US";
	}
})();

i18n.use(initReactI18next)
	.init({
		fallbackLng: "en-US",
		interpolation: {
			escapeValue: false,
		},
		lng: lang,
		resources: i18nResources,
	})
	.then(() => {
		document.title = t("limeStartPage");
	})
	.catch(console.error);

document.documentElement.lang = lang;

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
	<QueryClientProvider client={queryClient}>
		<App />
	</QueryClientProvider>,
);

printWelcomeToConsole();
